<template>
  <div class="style-wrap" :style="cssVars">
    <slot/>
  </div>
</template>

<script>

export default {
  name: 'StyleWrap',
  computed: {
    cssVars () {
      const installBtnBg = typeof this.$store.getters.installButton.backgroundColor === 'string' ? this.$store.getters.installButton.backgroundColor : this.$store.getters.colors.themeColor;
      const installBtnText = typeof this.$store.getters.installButton.textColor === 'string' ? this.$store.getters.installButton.textColor : '#fff';
      return {
        '--bs-primary': this.$store.getters.colors.themeColor,
        '--bs-primary-rgb': this.hexToRgb(this.$store.getters.colors.themeColor),
        '--bs-install-bg': installBtnBg,
        '--bs-install-bg-rgb': this.hexToRgb(installBtnBg),
        '--bs-install-text': installBtnText,
        '--bs-install-text-rgb': this.hexToRgb(installBtnText),
        '--bs-header-color': this.$store.getters.colors.headerColor,
        '--bs-header-color-rgb': this.hexToRgb(this.$store.getters.colors.headerColor)
      }
    }
  },
  methods: {
    hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? parseInt(result[1], 16) + "," + parseInt(result[2], 16) + "," + parseInt(result[3], 16) : null;
    }
  },
}
</script>

<style lang="scss">
.style-wrap {
  height: 100vh;
  overflow: hidden;
  .bg-install {
    background-color: var(--bs-install-bg);
    color: var(--bs-install-text);
  }
  .bg-header {
    background-color: var(--bs-header-color);
  }
}
</style>